import { defineComponent as _defineComponent } from 'vue'
import { getHTMLText, toDetail } from '@/utils'
import routerByNoticeTag, { getNoticeTagName } from '@/utils/noticeTag'
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Carousel',
  props: {
    list: null
  },
  setup(__props: any) {

const props = __props as {
  /** 只显示三个 */
  list: NoticeItem[]
};


const current = ref(0)

const currentData = computed(() => {
  return props.list[current.value] || {}
})

function prev() {
  if (current.value <= 0) {
    current.value = props.list.length - 1
  } else {
    current.value--
  }
}
function next() {
  if (current.value >= 2 || props.list.length - 1 < current.value + 1) {
    current.value = 0
  } else {
    current.value++
  }
}

onMounted(() => {
  timeourNext()
})
onBeforeUnmount(() => {
  timeourNext_cancel()
})

const timer = ref()
function timeourNext() {
  timer.value = setTimeout(() => {
    next()
  }, 5 * 1000)
}
function timeourNext_cancel() {
  clearTimeout(timer.value)
}

watch(current, () => {
  timeourNext_cancel()
  timeourNext()
})

function onClickTag(item: NoticeItem) {
  routerByNoticeTag(item.noticeTag)
}

function onClick(item: NoticeItem) {
  toDetail(item)
}

return { __sfc: true,props, current, currentData, prev, next, timer, timeourNext, timeourNext_cancel, onClickTag, onClick, getHTMLText, getNoticeTagName }
}

})